<div class="sat-dialog-shell">
  <div class="sat-dialog-header">
    <h2 mat-dialog-title class="sat-dialog-title">{{ title }}</h2>
    <button type="button" class="sat-dialog-close" (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="sat-dialog-body">
    <form [formGroup]="formGroup" class="sat-dialog-form">
      <div class="sat-form-field">
        <label class="sat-form-label" for="categoryName">Category Name *</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sat-field-control sat-field-control--no-subscript">
          <input
            id="categoryName"
            matInput
            formControlName="CategoryName"
            placeholder="e.g., Digital Services, Loyalty Programs"
            required />
        </mat-form-field>
        <div
          class="sat-inline-error"
          *ngIf="formGroup.get('CategoryName')?.hasError('required') && formGroup.get('CategoryName')?.touched">
          Category name is required
        </div>
        <div class="sat-inline-error" *ngIf="formGroup.get('CategoryName')?.hasError('apiError')">
          {{ formGroup.get('CategoryName')?.getError('apiError') }}
        </div>
      </div>

      <div class="sat-form-field sat-color-picker">
        <label class="sat-form-label">Display Color *</label>
        <div class="sat-color-swatches" role="listbox" aria-label="Display color">
          <button
            type="button"
            *ngFor="let color of displayColors"
            class="sat-color-swatch"
            role="option"
            [class.sat-color-swatch--selected]="isColorSelected(color)"
            [ngClass]="'sat-color-swatch--' + color"
            [attr.aria-selected]="isColorSelected(color)"
            (click)="selectColor(color)"
            [attr.aria-label]="color">
          </button>
        </div>
        <div class="sat-inline-error" *ngIf="formGroup.get('DisplayColor')?.hasError('apiError')">
          {{ formGroup.get('DisplayColor')?.getError('apiError') }}
        </div>
      </div>

      <div class="sat-form-field">
        <label class="sat-form-label" for="categoryDescription">Description (optional)</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sat-field-control sat-field-control--no-subscript">
          <input
            id="categoryDescription"
            matInput
            formControlName="Description"
            placeholder="e.g., Store digital capability flags for online ordering and delivery" />
        </mat-form-field>
        <div class="sat-inline-error" *ngIf="formGroup.get('Description')?.hasError('apiError')">
          {{ formGroup.get('Description')?.getError('apiError') }}
        </div>
      </div>

      <div class="sat-info-box" *ngIf="!isEditMode">
        After creating the category, use '+ Add Type' on the category header to add attribute types
        within it.
      </div>

      <div class="sat-contents-box" *ngIf="isEditMode">
        <div class="sat-contents-box__title">Category Contents</div>
        <p class="sat-contents-box__text">
          This category contains
          <strong>{{ attributeTypeCount }} attribute type{{ attributeTypeCount === 1 ? '' : 's' }}</strong>:
          {{ attributeTypeNames }}.
        </p>
      </div>

      <div class="sat-delete-section" *ngIf="isEditMode">
        <button type="button" class="sat-btn sat-btn--danger sat-btn--block" (click)="onDelete()">
          Delete Category
        </button>
        <p class="sat-delete-warning">
          Deleting a category will also remove all attribute types and values within it. This action
          cannot be undone.
        </p>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="sat-dialog-footer">
    <button type="button" class="sat-btn sat-btn--outline" (click)="onCancel()" [disabled]="isSaving">
      Cancel
    </button>
    <button type="button" class="sat-btn sat-btn--primary" (click)="onSave()" [disabled]="isSaving">
      {{ saveButtonLabel }}
    </button>
  </mat-dialog-actions>
</div>
